export default {
    "Van Cranenbroek": "Van Cranenbroek",
    "Menu": "Menu",
    "What are you looking for?": "Waar ben je naar op zoek?",
    "back": "terug",
    "Filtering": "Filteren",
    "Clear all": "Alles wissen",
    "Show more": "Meer tonen",
    "Show less": "Minder tonen",
    "Price": "Prijs",
    "to": "tot",
    "Enter a correct value": "Voer een correcte waarde in",
    "Popularity": "Populariteit",
    "Newest": "Nieuwste",
    "Yes": "Ja",
    "No": "Nee",
    "Name (A-Z)": "Naam (A-Z)",
    "Name (Z-A)": "Naam (Z-A)",
    "Price (Ascending)": "Prijs (Oplopend)",
    "Price (Descending)": "Prijs (Aflopend)",
    "Categories": "Categorie\u00ebn",
    "Apply": "Toepassen",
    "No products were found in this category.": "Er zijn geen producten gevonden in deze categorie.",
    "Discount valid from {start} to {end}": "Korting geldig van {start} tot {end}",
    "More info": "Meer info",
    "Subscribe to our newsletter": "Meld je aan voor onze nieuwsbrief",
    "Yes i subscribe!": "Ja ik doe mee!",
    "Follow us": "Volg ons",
    "Compare products": "Vergelijk producten",
    "Compare": "Vergelijk",
    "Edit": "Aanpassen",
    "Change password": "Wachtwoord veranderen",
    "Contact information": "Contact informatie",
    "Personal information": "Persoonlijke informatie",
    "Opening Hours": "Openingstijden",
    "Monday": "Maandag",
    "Tuesday": "Dinsdag",
    "Wednesday": "Woensdag",
    "Thursday": "Donderdag",
    "Friday": "Vrijdag",
    "Saturday": "Zaterdag",
    "Sunday": "Zondag",
    "Coffee corner": "Koffiehoek",
    "Extra information": "Extra informatie",
    "Phone": "Telefoon",
    "Special opening hours": "Speciale openingstijden",
    "No special opening hours": "Geen speciale openingstijden",
    "Subject to change. Deviating opening hours (holidays etc.) are listed below under Special opening hours.": "Onder voorbehoud van wijzigingen. Afwijkende openingstijden (feestdagen e.d.) worden hieronder vermeld bij Speciale openingstijden.",
    "E-mailadress": "E-mailadres",
    "Subject": "Onderwerp",
    "Select a subject": "Selecteer een onderwerp",
    "Store": "Winkel",
    "Stores": "Winkels",
    "No specific store": "Geen specifieke winkel",
    "Question": "Vraag",
    "Fields marked with * are required.": "Velden gemarkeerd met * zijn verplicht",
    "Submit contact request": "Verstuur contactverzoek",
    "Addition": "Toevoeging",
    "Declaration of conformity": "Conformiteitsverklaring",
    "Download": "Download",
    "House number": "Huisnummer",
    "First name": "Voornaam",
    "Last name": "Achternaam",
    "Phone number": "Telefoonnummer",
    "The {_field_} field must be selected.": "Het {_field_} veld moet geselecteerd zijn.",
    "The subject field must be selected.": "Het onderwerp veld moet geselecteerd zijn.",
    "Your message has been sent": "Je bericht is verstuurd",
    "In Stock in {count} store(s)": "Op voorraad in {count} winkel(s)",
    "I accept": "Ik ga akkoord met",
    "Valid until": "Geldig t/m",
    "Sort by": "Sorteren op",
    "Show store": "Bekijk winkel",
    "Chosen filters": "Gekozen filters",
    "Show {totalItems} results": "Toon {totalItems} resultaten",
    "Sidebar menu - Quick Access": "Sidebar menu - Snel naar",
    "Quick access to": "Ga snel naar",
    "Call": "Bel",
    "Atmospheric image of": "Sfeerbeeld van",
    "In stock": "Op voorraad",
    "Specifications": "Specificaties",
    "There was a problem with the subscription: This email address is already subscribed.": "Dit e-mailadres is al geabonneerd.",
    "Thank you for your subscription.": "Bedankt voor je inschrijving.",
    "Choose your {option}": "Kies een {option}",
    "Other variants": "Andere varianten",
    "Remove from wishlist": "Verwijderen van verlanglijst",
    "Select an option to show stock information": "Selecteer een maat of model om de winkelvoorraad te tonen",
    "Promotion till": "Actieprijs geldig t/m",
    "Out of stock": "Niet op voorraad",
    "In stock in {count} store(s)": "Op voorraad in {count} winkel(s)",
    "Other Variants": "Andere varianten",
    "{count} items in stock": "{count} stuks op voorraad",
    "Less then {count} items in stock": "Minder dan {count} stuks op voorraad",
    "Others also viewed": "Anderen bekeken ook",
    "Frequently asked questions": "Veelgestelde vragen",
    "Most asked questions": "Meestgestelde vragen",
    "Where are you searching for?": "Waar ben je naar op zoek?",
    "Search on subject": "Zoek op onderwerp",
    "This is what we found": "Dit hebben we gevonden",
    "Product description": "Productomschrijving",
    "Privacy checkbox is required": "Je moet akkoord gaan met de privacyverklaring",
    "We didn't found any results": "We hebben 0 resultaten gevonden",
    "Sorry, we couldn't find anything based on your search. Please change your search request, or search by category for your question.": "Sorry, we hebben niets kunnen vinden op basis van je zoekopdracht. Verander je zoekopdracht of zoek op categorieen naar je vraag.",
    "Contact": "Contact",
    "Complaints? We\u2019re here to help!": "Klachten? Wij helpen je graag!",
    "We\u2019re sorry to hear that you have a complaint. We will do our best to resolve this as soon as possible.": "We vinden het vervelend om te horen dat je een klacht hebt. We zullen ons best doen om dit zo snel mogelijk op te lossen.",
    "Can we help you with something?": "Kunnen we je ergens mee helpen?",
    "Do you need a helping hand? We\u2019re here to help you with any questions you may have.": "Heb je een helpende hand nodig? We helpen je graag met al je vragen.",
    "Drag your photo here or use the upload button": "Sleep jouw foto hierheen of gebruik de upload knop",
    "SVG, PNG, JPG of GIF (max. 200mb)": "SVG, PNG, JPG of GIF (max. 200mb)",
    "Uploaden": "Uploaden",
    "Drop your foto here": "Sleep jouw foto hierheen",
    "My favorites": "Mijn favorieten",
    "You have no products in your favorites yet.": "Je hebt nog geen producten in je favorieten.",
    "Low stock": "Let op: Zeer beperkte voorraad \u2013 beschikbaarheid in de winkel kan niet worden gegarandeerd.",
    "Store stock": "Winkelvoorraad",
    "Put on wishlist": "Toevoegen aan verlanglijst",
    "Read more": "Lees meer",
    "Search suggestions": "Suggesties",
    "Popular products": "Populaire producten",
    "Price descending": "Prijs (Aflopend)",
    "Price ascending": "Prijs (Oplopend)"
}